import { matrixFactory } from '@mews/b2b-ui';
import SimpleTableHeaderCell from './SimpleTableHeaderCell';
import { TableCellElement, TableElement, TableWrapperElement } from './styles';

const CommanderResponsiveTable = matrixFactory({
    Matrix: TableElement,
    // @ts-expect-error $TSFixMeError: Type '({ columnAlignment, title }: Props) => JSX.Element' is not assignable to type 'typeof TableHeaderCell'.
    MatrixHeaderCell: SimpleTableHeaderCell,
    MatrixCell: TableCellElement,
});

const CommanderTable = (props: $TSFixMe) => (
    <TableWrapperElement>
        <CommanderResponsiveTable {...props} />
    </TableWrapperElement>
);

export default CommanderTable;
